import { IPersonCert, PersonCertMapper, IPersonCertDTO } from "./IPersonCert";
import { ICompany } from "./ICompany";
import { ICert } from "./ICert";
import { fromHtmlEntities } from "@sg-core/index";

export interface IPersonCerts { [key: string]: IPersonCert | undefined };

export interface IPerson {
    id: number;
    fullname: string;
    firstname: string;
    surname: string;
    email?: string;
    phone?: string;
    company?: ICompany["id"];
    image?: string;
    certs?: IPersonCerts;
    gateId?: string;
    loggedAt?: string;
    lang?: "fi" | "en" | "se";
    notifyBy?: "email" | "sms" | "email_sms";
};

export type IPersonFormData = Partial<Omit<IPerson, "id">>;

export interface IPersonCertsDTO { [key: string]: IPersonCertDTO | undefined };

export interface IPersonDTO {
    id: number;
    nimi: string;
    etunimi: string;
    sukunimi: string;
    meiliosoite?: string;
    puhelin?: string;
    yritys?: number;
    kuva?: string;
    patevyydet?: IPersonCertsDTO;
    kieli?: "fi" | "en" | "se";
    ilmoitustapa?: "email" | "sms" | "email_sms";
    kirjautumisaika?: string;
    gate_tunniste?: string;
};

export interface IPersonSearchParams {
    text: string;
    requiredCerts?: Array<ICert["refrenceName"]>;
};

export const PersonMapper = {

    domainToApi: (domain: IPerson): IPersonDTO => {
        const certs: IPersonCerts = domain.certs || {};

        const reduceCert = (acc: IPersonCertsDTO, reference: string) => {
            const cert = certs[reference];
            if (cert) {
                acc[reference] = PersonCertMapper.domainToApi(cert);
            }
            return acc;
        };

        return ({
            id: domain.id,
            nimi: domain.fullname,
            etunimi: domain.firstname,
            sukunimi: domain.surname,
            meiliosoite: domain.email,
            puhelin: domain.phone,
            yritys: domain.company,
            kuva: domain.image,
            patevyydet: Object.keys(certs).reduce(reduceCert, {}),
            ilmoitustapa: domain.notifyBy,
            kieli: domain.lang,
        })
    },

    apiToDomain: (api: IPersonDTO): IPerson => {
        const patevyydet: IPersonCertsDTO = api.patevyydet || {};

        const reducePatevyys = (acc: IPersonCerts, reference: string) => {
            const patevyys = patevyydet[reference];
            if (patevyys && patevyys.viitenimi) {
                acc[patevyys.viitenimi] = PersonCertMapper.apiToDomain(patevyys);
            }
            return acc;
        };

        const fullname = api.nimi || [api.sukunimi, api.etunimi].join(" ");

        return ({
            id: api.id,
            fullname: fullname ? fromHtmlEntities(fullname) : "",
            firstname: api.etunimi ? fromHtmlEntities(api.etunimi) : "",
            surname: api.sukunimi ? fromHtmlEntities(api.sukunimi) : "",
            email: api.meiliosoite,
            phone: api.puhelin,
            company: api.yritys ? api.yritys : undefined,
            image: api.kuva,
            certs: Object.keys(patevyydet).reduce(reducePatevyys, {}),
            notifyBy: api.ilmoitustapa,
            gateId: api.gate_tunniste,
            loggedAt: api.kirjautumisaika,
            lang: api.kieli,
        })
    }
};
